import type { ViewerDeviceClass } from "./viewer-profile";

export interface ViewerPerformanceBudget {
  firstRenderableMs: number;
  fullyLoadedMs: number;
  interactionResponseMs: number;
  maximumDevicePixelRatio: number;
}

export const VIEWER_LOAD_STALL_TIMEOUT_MS = 60_000;

export const viewerPerformanceBudgets: Readonly<Record<ViewerDeviceClass, ViewerPerformanceBudget>> = {
  desktop: {
    firstRenderableMs: 8_000,
    fullyLoadedMs: 30_000,
    interactionResponseMs: 100,
    maximumDevicePixelRatio: 2,
  },
  tablet: {
    firstRenderableMs: 12_000,
    fullyLoadedMs: 45_000,
    interactionResponseMs: 150,
    maximumDevicePixelRatio: 1.5,
  },
  mobile: {
    firstRenderableMs: 15_000,
    fullyLoadedMs: 60_000,
    interactionResponseMs: 200,
    maximumDevicePixelRatio: 1,
  },
};
